/**
 * The team phone's device token for /join/<pin>.
 *
 * The server issues the token on the first check-in. The phone keeps it in
 * localStorage so next week the same phone gets "Welcome back". Storage can
 * be missing or can throw (private mode, blocked site data, some in-app
 * browsers), so every access is in try/catch and a copy stays in memory for
 * the life of the tab.
 */

const KEY = 'trivia:deviceToken';
const TOKEN_RE = /^[A-Za-z0-9_-]{32,64}$/;

let memoryToken: string | null = null;

export function getDeviceToken(): string | null {
  if (memoryToken) return memoryToken;
  try {
    const stored = window.localStorage.getItem(KEY);
    if (stored && TOKEN_RE.test(stored)) {
      memoryToken = stored;
      return stored;
    }
  } catch {
    /* storage blocked: fall through */
  }
  return null;
}

export function setDeviceToken(token: string): void {
  if (!TOKEN_RE.test(token)) return;
  memoryToken = token;
  try {
    window.localStorage.setItem(KEY, token);
  } catch {
    /* storage blocked: keep the memory copy */
  }
}

/** For tests only. */
export function resetDeviceTokenMemory(): void {
  memoryToken = null;
}
